import { AttributeText } from './attribute-text';

export const EmptyValue = () => (
  <AttributeText sx={{ color: 'text.secondary' }}>Empty</AttributeText>
);
